import { TimeInterval } from './time-interval'

export class MeetingStand {
    id: number;
    symbol: string;
    meetingAreaId: number;
    name: string;
    timeIntervals: TimeInterval[] = [];
}
